import React from "react";
import { whyChooseData } from "../data/mock";
import { Card, CardContent } from "./ui/card";
import {
  ShieldCheck,
  Scale,
  TrendingUp,
  Truck,
  Banknote,
  Headphones,
} from "lucide-react";

const iconMap = {
  ShieldCheck,
  Scale,
  TrendingUp,
  Truck,
  Banknote,
  Headphones,
};

export const WhyChooseSection = () => {
  return (
    <section id="why-choose" className="py-24 md:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-emerald-50 rounded-full px-4 py-1.5 mb-6">
            <div className="w-2 h-2 rounded-full bg-emerald-500" />
            <span className="text-emerald-700 text-sm font-semibold uppercase tracking-wider">
              Why Choose Us
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Why Industries Trust AM Scrap Dealers
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            We bring transparency, reliability, and professionalism to every scrap transaction.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {whyChooseData.map((item, i) => {
            const Icon = iconMap[item.icon];
            return (
              <Card
                key={i}
                className="group border-0 bg-white shadow-md shadow-emerald-900/[0.03] hover:shadow-xl hover:shadow-emerald-900/[0.08] rounded-2xl transition-all duration-300 hover:-translate-y-1 overflow-hidden"
              >
                <CardContent className="p-8">
                  <div className="w-14 h-14 rounded-2xl bg-emerald-50 flex items-center justify-center mb-6 group-hover:bg-emerald-100 transition-colors duration-300">
                    {Icon && (
                      <Icon className="w-7 h-7 text-emerald-700 group-hover:text-emerald-600 transition-colors" />
                    )}
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-2.5">
                    {item.title}
                  </h3>
                  <p className="text-slate-500 leading-relaxed text-[15px]">
                    {item.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
